import { ApolloProvider } from '@apollo/client/react';
import type { PropsWithChildren } from 'react';
import { initI18n } from '@/shared/i18n';
import { apolloClient } from './apollo';
import { PwaUpdateProvider } from './PwaUpdateProvider';
import { PushProvider } from '@/modules/native/push/PushProvider';

initI18n();

export const AppProviders = ({ children }: PropsWithChildren) => (
  <ApolloProvider client={apolloClient}>
    <PushProvider>{children}</PushProvider>
    <PwaUpdateProvider />
  </ApolloProvider>
);
